module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_null_null@2x.f8c70429.png";